{
  "Mon": "Lundi",
  "Tue": "Mardi",
  "Wed": "Mercredi",
  "Thu": "Jeudi",
  "Fri": "Vendredi",
  "Sat": "Samedi",
  "Sun": "Dimanche",
  "CORE": {
    "notificationDateFormat": "d/M/yy",
    "update": "chargement des données....",
    "youAreOffline": "Device offline! Connect to a network and try again later!",
    "comeBack": "{{icon}} vos skis vous attendent",
    "help": "Aide",
    "notification": {
      "ok": "J'ai compris"
    },
    "skiHire": "Location de Ski"
  },
  "ALPINSKIHIRE": {
    "AR": {
      "sidebar": {
        "hotline": "Assistance télephonique"
      },
      "start": {
        "topTowns": "Des localités de Location de Ski de qualité",
        "selectBookingParametersFact3": "Chez Alpy.com vous payez en monnaie de votre choix. L'échange est sans frais extra. Nos cours des changes sont mis à jour une fois par jour.",
        "searchHeadline": "Où souhaitez-vous louer vos skis ou votre snowboard ?"
      },
      "showTownReserveEarlyEnoughInfo": "Veuillez tenir compte du fait que les loueurs de skis peuvent tomber à court de matériel durant la saison. Nous vous recommandons de ce fait de toujours réserver à l'avance.",
      "shopSearch": {
        "formSearchButtonLabel": "CHERCHER",
        "promocode": {
          "couponCodeIsInCart": "Le code promo {{ code }} a été ajouté à votre panier et sera ajouté à la page de paiement.",
          "typePromo": "PROMO",
          "typeCoupon": "COUPON"
        }
      }
    },
    "SM": {
      "sidebar": {
        "hotline": "Assistance télephonique"
      },
      "start": {
        "topTowns": "Des localités de Location de Ski de qualité",
        "searchHeadline": "Où souhaitez-vous louer vos skis ou votre snowboard ?",
        "indexAdvantagesHeadline": "Bienvenue chez Skimarie !",
        "indexText": "Skimarie vous offre la location de skis et de snowboards avec l'équipment le plus moderne. Vous choisissez d'abord un domaine skiable et ensuite votre équipement de ski à base du meilleur prix, de la distance la moins éloignée ou bien d'un mélange de ces deux critères. Vous allez voir, avec Skimarie vous trouverez les meilleures offres de location de skis sur internet. Profitez de notre choix énorme de domaines skiables et de magasins à Alpe d'Huez, Avoriaz, Chamonix, Chatel, Courchevel, Flaine, La Plagne, La Rosière, La Tania, Les Arcs, Les Carroz d'Araches, Les Deux Alpes, Les Gets, Les Houches, Meribel, Morzine, Samoens, Tignes Le Lac, Val d'Isere, Val Thorens et beaucoup d'autres endroits ! Après avoir chosi un magasin Skimarie vous propose jusqu'à quatre catégories de fixations pour skis et snowboards en vous laissant sélectionner le model de ski ou de snowboard directement dans le magasin. Notre équipe est à votre disposition pour tout autre renseignement. Skimarie est le site internet de location de skis pour des gens intelligents.",
        "advantages": {
          "point1": "Meilleur marché que sur place !",
          "point2": "Paiement en ligne sécurisé !",
          "point3": "Grand choix de magasins !"
        }
      },
      "showTownReserveEarlyEnoughInfo": "Il est recommandé de réserver en ligne à l'avance, les magasins pouvant être à court de stock pendant la saison de l'Hiver.",
      "shopSearch": {
        "formSearchButtonLabel": "CHERCHER",
        "promocode": {
          "couponCodeIsInCart": "Le code promo {{ code }} a été ajouté à votre panier et sera ajouté à la page de paiement.",
          "typePromo": "PROMO",
          "typeCoupon": "COUPON"
        }
      },
      "heroBenefits": {
        "headline": "Obtenez les meilleurs tarifs de location",
        "subheadline": "jusqu'à <span>-{{discount}}&nbsp;%*</span>",
        "benefitsHeader": "Avantages",
        "benefitFirst": "Économisez jusqu'à -{{discount}}&nbsp;% des économies par rapport aux prix pratiqués dans les magasins",
        "benefitSecond": "Annulation et changement de réservation flexibles",
        "benefitThird": "Réservation en ligne - retrait en magasin",
        "benefitFourth": "Plus de 1000 magasins en ligne"
      }
    },
    "S2": {
      "sidebar": {
        "hotline": "Assistance télephonique"
      },
      "start": {
        "topTowns": "Des localités de Location de Ski de qualité",
        "searchHeadline": "Où souhaitez-vous louer vos skis ou votre snowboard ?",
        "indexAdvantagesHeadline": "Bienvenue chez Simplytoski !",
        "indexText": "Simplytoski vous offre la location de skis et de snowboards avec l'équipment le plus moderne. Vous choisissez d'abord un domaine skiable et ensuite votre équipement de ski à base du meilleur prix, de la distance la moins éloignée ou bien d'un mélange de ces deux critères. Vous allez voir, avec Simplytoski vous trouverez les meilleures offres de location de skis sur internet. Profitez de notre choix énorme de domaines skiables et de magasins à Alpe d'Huez, Avoriaz, Chamonix, Chatel, Courchevel, Flaine, La Plagne, La Rosière, La Tania, Les Arcs, Les Carroz d'Araches, Les Deux Alpes, Les Gets, Les Houches, Meribel, Morzine, Samoens, Tignes Le Lac, Val d'Isere, Val Thorens et beaucoup d'autres endroits ! Après avoir chosi un magasin Skimarie vous propose jusqu'à quatre catégories de fixations pour skis et snowboards en vous laissant sélectionner le model de ski ou de snowboard directement dans le magasin. Notre équipe est à votre disposition pour tout autre renseignement. Simplytoski est le site internet de location de skis pour des gens intelligents.",
        "advantages": {
          "point1": "Meilleur marché que sur place !",
          "point2": "Paiement en ligne sécurisé !",
          "point3": "Grand choix de magasins !"
        }
      },
      "showTownReserveEarlyEnoughInfo": "Il est recommandé de réserver en ligne à l'avance, les magasins pouvant être à court de stock pendant la saison de l'Hiver.",
      "shopSearch": {
        "formSearchButtonLabel": "CHERCHER",
        "promocode": {
          "couponCodeIsInCart": "Le code promo {{ code }} a été ajouté à votre panier et sera ajouté à la page de paiement.",
          "typePromo": "PROMO",
          "typeCoupon": "COUPON"
        }
      },
      "heroBenefits": {
        "headline": "Obtenez les meilleurs tarifs de location",
        "subheadline": "jusqu'à <span>-{{discount}}&nbsp;%*</span>",
        "benefitsHeader": "Avantages",
        "benefitFirst": "Économisez jusqu'à -{{discount}}&nbsp;% des économies par rapport aux prix pratiqués dans les magasins",
        "benefitSecond": "Annulation et changement de réservation flexibles",
        "benefitThird": "Réservation en ligne - retrait en magasin",
        "benefitFourth": "Plus de 1000 magasins en ligne"
      }
    },
    "MC": {
      "sidebar": {
        "hotline": "Assistance télephonique"
      },
      "start": {
        "topTowns": "Des localités de Location de Ski de qualité",
        "selectBookingParametersFact3": "Chez LOCATION-SKI-MOINS-CHER.com vous payez en monnaie de votre choix. L'échange est sans frais extra. Nos cours des changes sont mis à jour une fois par jour.",
        "searchHeadline": "Où souhaitez-vous louer vos skis ou votre snowboard ?",
        "seoTextHeader": "Location Ski Moins Cher, les meilleurs prix pour votre location de skis",
        "seoText": "En 10 ans, Location Ski Moins Cher est devenu un acteur majeur dans la location de skis sur internet à prix discount.<br /><br />Fort de partenariats noués avec les plus grands réseaux de magasins de ski, Location Ski Moins Cher vous fait bénéficier de 20% à 50% de réduction sur votre location de matériel de ski dans plus de 500 stations de ski dans 7 pays en Europe : France, Italie, Andorre, Autriche, Allemagne, Suisse et République Tchèque.<br /><br />Louez vos skis avec Location Ski Moins Cher en 3 étapes.<br /><br />1. Sélectionnez votre station et votre magasin parmi notre réseau de magasins de ski. Indiquez votre date de début de séjour et la durée de votre location de skis.<br />2. Sélectionnez ensuite votre matériel selon votre niveau et surtout vos envies parmi le large choix d'équipements de ski : skis adulte, skis femme, skis enfant, skis baby, snowboard.<br />3. Imprimez votre bon d'échange et présentez-le à votre arrivée en station pour retirez votre matériel de ski."
      },
      "showTownReserveEarlyEnoughInfo": "Nous recommandons de réserver à l'avance. Les magasins n'ont pas toujours le stock nécessaire pendant la saison.",
      "shopSearch": {
        "formSearchButtonLabel": "CHERCHER",
        "promocode": {
          "couponCodeIsInCart": "Le code promo {{ code }} a été ajouté à votre panier et sera ajouté à la page de paiement.",
          "typePromo": "PROMO",
          "typeCoupon": "COUPON"
        }
      },
      "heroBenefits": {
        "headline": "Bénéficiez des avantages d'une réservation en ligne",
        "subheadline": "jusqu'à <span>-{{discount}}&nbsp;%*</span>",
        "benefitsHeader": "Notre offre",
        "benefitFirst": "Annulation et changement de réservation faciles",
        "benefitSecond": "Économisez jusqu'à -{{discount}}&nbsp;% des économies par rapport aux prix pratiqués dans les magasins",
        "benefitThird": "Aucun frais de transaction",
        "benefitFourth": "Plus de 1000 magasins en ligne"
      }
    },
    "DF": {
      "sidebar": {
        "hotline": "Assistance télephonique"
      },
      "start": {
        "topTowns": "Des localités de Location de Ski de qualité",
        "selectBookingParametersFact3": "Chez skidiscount.fr vous payez en monnaie de votre choix. L'échange est sans frais extra. Nos cours des changes sont mis à jour une fois par jour.",
        "searchHeadline": "Où souhaitez-vous louer vos skis ou votre snowboard ?",
        "seoTextHeader": "Un équipement de qualité pour skier en toute tranquillité",
        "seoText": "Skiez en toute tranquillité ! Ski Discount s'engage pour votre plaisir et votre sécurité.    Les professionnels de notre réseau travaillent aux côtés des marques pour vous proposer    un matériel de ski parfaitement entretenu et préparé pour vous.<br /><br />Avec Ski Discount, louez votre matériel jusqu'à 60% moins cher qu'en magasin, en seulement trois étapes:<br /><br />1. Choisissez votre station et votre magasin parmi notre réseau de plus de 600 loueurs de ski professionnels, dans 7 pays européens. Indiquez la date de votre 1er jour de ski et la durée de votre séjour.<br />2. Sélectionnez votre matériel selon votre niveau et vos envies ! Ski Discount vous propose 4 gammes de matériel de ski et un large choix de produits : ski homme    et femme, snowboard, miniski, ski baby, junior et ado.<br />3. Payez en ligne grâce à notre interface de paiement sécurisé, et recevez immédiatement    votre bon d'échange par email. A partir de 17h la veille de votre 1er jour de ski,    retirez votre matériel en station."
      },
      "showTownReserveEarlyEnoughInfo": "Il est prudent de réserver à l'avance. Les magasins peuvent être à court de stock pendant l'hiver.",
      "shopSearch": {
        "formSearchButtonLabel": "CONTINUER",
        "promocode": {
          "couponCodeIsInCart": "Le code promo {{ code }} a été ajouté à votre panier et sera ajouté à la page de paiement.",
          "typePromo": "PROMO",
          "typeCoupon": "COUPON"
        }
      },
      "heroBenefits": {
        "headline": "Les meilleurs prix de location de ski en ligne",
        "subheadline": "Jusqu'à <span>-{{discount}}&nbsp;%</span> de remise*",
        "benefitsHeader": "Avantages",
        "benefitFirst": "Meilleurs prix en ligne : jusqu'à -{{discount}}&nbsp;% des économies par rapport aux prix pratiqués dans les magasins",
        "benefitSecond": "Annulation et changement de réservation faciles",
        "benefitThird": "Aucun frais de réservation",
        "benefitFourth": "Plus de 1000 magasins en ligne"
      }
    },
    "offer": {
      "title": "Pourquoi réserver avec {{ platformname }}"
    },
    "start": {
      "advantagesHeadline": "Meilleurs prix garantis pour la location de ski en effectuant une réservation en ligne",
      "listedBrands": "Marques proposées"
    },
    "sidebar": {
      "hotlineItalic": "Laissez-nous vous aider !",
      "callNow": "Appelez maintenant au : "
    },
    "shopSearch": {
      "validation": {
        "selectAgeForEveryChild": "Merci de noter l'âge de chaque enfant (âge au début de la location)",
        "onePersonRequired": "Choisissez une personne au minimum",
        "enterTown": "Choisissez votre station de ski"
      },
      "minified": {
        "users": "{{ number_adults }} Adultes, {{ number_children }} Enfants",
        "date": "{{ start_date }} - {{ end_date }}",
        "dateFormat": "EEEEEE d/M/yy"
      },
      "datePickerDisplayFormat": "EEEEEE d/M/yy",
      "datePickerPreviousMessage": "Vous pouvez retirer votre matériel de location dans la boutique le <span>{{ date }}</span> à 16:00. Ski de nuit exclu.",
      "datePickerPreviousMessageDateFormat": "d/M/yy",
      "formSearchLabel": "Localité, domaine skiable, pays, nom du magasin, ...",
      "formSearchInfo": "Un moment s'il vous plaît, la station désirée est recherchée...",
      "formSearchResultDescription": "({{region}}, {{province}})",
      "formSearchResultShopNumber": "{{ count }} magasin(s)",
      "formSearchResultShowAll": "Liste tous les {{ count }} résultats",
      "formSearchResultGroupLocations": "Station de ski",
      "formSearchResultGroupShops": "Shops",
      "formSearchResultGroupRegions": "Région",
      "formSearchResultGroupCountries": "Pays",
      "formSearchButtonLabelDelivery": "À partir de {{price}}",
      "deliverToHotel": "Je souhaite que l'équipement soit livré à mon hébergement – GRATUITEMENT !",
      "formStartDate": "1er jour de location",
      "formEndDate": "Dernier jour",
      "formNumberOfPeople": "Nombre de personnes",
      "formPeopleCount": {
        "numberOfPeople": "{{ number_adults }} {{ pluralizeAdult }} {{ number_children }} {{ pluralizeChildren }}",
        "adultNone": "Adultes",
        "adultSingle": "Adulte",
        "adultMultiple": "Adultes",
        "childNone": "Enfants",
        "childSingle": "Enfant",
        "childMultiple": "Enfants"
      },
      "formAdultsLabel": "Adultes",
      "formAdultsLabelInfo": "Plus de 18 ans au début de la location",
      "formChildrenLabel": "Enfants",
      "formChildrenLabelInfo": "Moins de 18 ans au début de la location",
      "formChildInputLabelInfo": "Quel âge a votre enfant ? Quel âge aura votre enfant au début de la location ?",
      "formChildInputPlaceholder": "Quel âge?",
      "formPromotionCode": "Code promotion",
      "formPromotionCodeNotFound": "Ce code promotion n'existe pas.",
      "noResults": "Aucun résultat trouvé"
    },
    "navigation": {
      "skihire": "Location de Ski",
      "skischool": "Écoles de ski",
      "accommodation": "Hébergements",
      "aboutUs": "Qui sommes-nous",
      "helpCenter": "Aide",
      "subnavBooking": "Réservation",
      "subnavAdditionalOffers": "Offres Additionnelles",
      "subnavGroupBooking": "Réservation de groupes",
      "subnavTermsAndConditions": "Conditions générales de vente",
      "subnavBecomePartner": "Devenez notre partenaire",
      "subnavPrivacyPolicy": "Données personnelles",
      "subnavHelp": "Contact",
      "myAlpinresorts": "Mon Alpy.COM",
      "subnavLogin": "Connexion",
      "subnavLogout": "Déconnexion",
      "subnavBookingsAndCancellations": "Réservations et Annulations",
      "subnavPersonalSettings": "Paramètres personnels",
      "career": "Carrière",
      "blog": "Blog"
    },
    "geoIp": {
      "chooseACountry": "Veuillez sélectionner un pays"
    }
  },
  "ALPINSTATIC": {
    "aboutUs": {
      "title": "L'équipe d'Alpy.com",
      "metaDescription": "Vous trouverez ici toutes les informations sur l'équipe d'Alpy.com. Faites confiance à l'un des plus grands réseaux d'écoles et de loueurs de ski d'Europe!"
    },
    "imprint": {
      "title": "Mentions légales {{ productName }}",
      "metaDescription": ""
    },
    "privacy": {
      "title": "Protection des données personnelles d'{{ productName }}",
      "metaDescription": "Protection des données personnelles d'{{ productName }}"
    },
    "termsAndConditions": {
      "title": "Conditions Générales de Vente | {{ productName }}",
      "metaDescription": "Conditions générales de ventes d'{{ productName }}"
    },
    "additionalOffers": {
      "title": "Offres Additionnelles",
      "metaDescription": ""
    }
  },
  "ROUTES": {
    "CHECKOUT": {
      "PAYMENT": "payment",
      "CHECKOUT": "checkout"
    },
    "CANCELLATION": "annulez-votre-reservation",
    "SKIHIREENTRY": "location-ski",
    "COUNTRIES": "pays",
    "PRODUCTS": "products",
    "PRODUCT": {
      "FINISH": "finish"
    },
    "SKIHIRE": {
      "GROUPS": "groups",
      "PRODUCTS": "products",
      "SEARCH": "recherche"
    },
    "SKISCHOOLENTRY": "ecole-de-ski",
    "STATIC": {
      "SWISSPASS": "swisspass",
      "IMPRINT": "mentions-legales",
      "PRIVACYPOLICY": "dispositions-relatives-a-la-protection-des-donnees",
      "TERMSANDCONDITIONS": "conditions",
      "HELP": "support",
      "ABOUTUS": "a-propos-de-nous",
      "ADDITIONALOFFERS": "offres-additionelles",
      "HOWTO": "comment-faire"
    }
  }
}